
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iforklift/contact-us",
      function () {
        return require("private-next-pages/iforklift/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iforklift/contact-us"])
      });
    }
  